// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'

Vue.prototype.$http = Axios

Vue.config.productionTip = false

let globalData = new Vue({
  data: {
    $baseUrl: process.env.API_BASE_URL
  },
  methods: {
    getApiUrl (path) {
      return this.data.$baseUrl + path
    }
  }
})

// console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_API_BASE_URL + 'a')
// console.log(process.env)

Vue.mixin({
  computed: {
    $baseUrl: {
      get: function () { return globalData.$data.$baseUrl },
      set: function (newBaseUrl) { globalData.$data.$baseUrl = newBaseUrl }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js